export type SurveyAnswersFormValues = Record<string, string[]>;

export type NormalizedSurveyAnswer = {
  questionId: number;
  response: string[];
};

export function normalizeSurveyAnswersForRequest(
  answers: SurveyAnswersFormValues
): NormalizedSurveyAnswer[] {
  return Object.entries(answers)
    .map(([questionId, response]) => {
      const normalized = response.map(value => value.trim()).filter(value => value.length > 0);
      if (normalized.length === 0) {
        return null;
      }

      return {questionId: Number(questionId), response: normalized};
    })
    .filter((entry): entry is NormalizedSurveyAnswer => entry !== null);
}
